export enum EConsentMode {
  GRANTED = 'granted',
  DENIED = 'denied'
}

export enum EPersonIncludeType {
  Access,
  Addresses,
  TargetComments,
  Integration,
  Phones,
  Preference,
  Responsible,
  Tax,
  EventConsolidated,
  FinancialConsolidated,
  HealthConsolidated,
  HistoryConsolidated,
  PhoneConsolidated,
  SubscriptionConsolidated,
  TechInfoConsolidated,
  UserConsolidated,
  StorageConsolidated,
}

export enum EAddressType {
  Others = 0,
  Home = 1,
  Business = 2,
}

export enum AppSource {
  None = 0,
  Actuar = 1,
  Treino = 2,
  Afig = 3,
  FacilFit = 4,
  PagueLa = 5,
  Toletus = 6,
  CatracaParaAcademia = 7,
  Act = 8,
  Reserva = 9,
  Ediz = 10,
}